import { render, staticRenderFns } from "./FilterByLabel.vue?vue&type=template&id=a671837e&scoped=true&"
import script from "./FilterByLabel.vue?vue&type=script&lang=js&"
export * from "./FilterByLabel.vue?vue&type=script&lang=js&"
import style0 from "./FilterByLabel.vue?vue&type=style&index=0&id=a671837e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671837e",
  null
  
)

export default component.exports